import axios from 'axios';
import React from 'react'

class S3Uploader extends React.Component {
  state = {
    presignedUrl: null,
    selectedFile: null
  }

  // Calculate the size of the file in MB
  sizeInMB = (file) => {
    return (file.size / (1024*1024)).toFixed(2);
  }

  ///////////////////////////////////////////////
  // Event Handlers
  ///////////////////////////////////////////////

  onFileChange = (event) => {
    this.setState({ selectedFile: event.target.files[0] }, () => {
      this.uploadFile();
    });
  }

  ///////////////////////////////////////////////
  // Axios
  ///////////////////////////////////////////////

  uploadFile = async () => {
    const file = this.state.selectedFile;
    const partSize = 5 * 1024 * 1024; // 5MB
    const partsCount = Math.ceil(file.size / partSize);
    let uploadProgress = Array(partsCount).fill(0);
    let total = 0;

    Spinner.show("Initializing upload...");
    const { data } = await axios.post('/api/attachments/new', {
      attachable_id: this.props.attachable_id,
      attachable_type: this.props.attachable_type,
      filename: file.name,
      content_type: file.type,
      size: file.size
    }, {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      }
    });

    // Method for uploading each part
    const uploadPart = async (url, partNumber, blob) => {
      const response = await axios.put(url, blob, {
        headers: {
          'Content-Type': file.type
        },
        onUploadProgress: function(progressEvent) {
          console.log(progressEvent);
          uploadProgress[partNumber - 1] = progressEvent.loaded;
          total = uploadProgress.reduce((acc, curr) => acc + curr, 0);
          Spinner.updatePercentage(`${Math.round((total / file.size) * 100)}%`);
        }
      });
      return {
        etag: response.headers.etag.replace(/"/g, ''),
        part_number: partNumber
      };
    };

    // Start the multipart upload
    const { key, upload_id, presigned_urls } = data;
    const uploadPromises = presigned_urls.map(({ part_number, url }) => {
      const start = (part_number - 1) * partSize;
      const end = Math.min(start + partSize, file.size);
      const blob = file.slice(start, end);
      return uploadPart(url, part_number, blob);
    });

    // Wait for all parts to upload
    Spinner.update(`Uploading ${file.name} (${this.sizeInMB(file)} MB)`);
    const uploadedParts = await Promise.all(uploadPromises);

    // Complete the multipart upload and create the attachment record
    Spinner.show("Finalizing...");
    const response = await axios.post('/api/attachments/create', {
      attachable_id: this.props.attachable_id,
      attachable_type: this.props.attachable_type,
      upload_id: upload_id,
      parts: uploadedParts,
      filename: file.name,
      content_type: file.type,
      size: file.size,
      file_type: this.props.file_type,
      key: key
    }, {
      headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      }
    });

    // Update the attachments list in the DOM
    if (response.data && response.data.attachments_list_html) {
      const attachmentsList = document.getElementById('attachments-list');
      if (attachmentsList) {
        attachmentsList.innerHTML = response.data.attachments_list_html;
        document.querySelector('#file-input').value = '';
      }
    }

    Spinner.complete('Upload successful!')
  }

  render() {
    return (
      <React.Fragment>
        <input type="file" onChange={this.onFileChange} id='file-input'></input>
      </React.Fragment>
  )}
}

export default S3Uploader

